module.exports = __webpack_public_path__ + "static/media/close_icon.a1064e46.svg";